import { render, staticRenderFns } from "./ConfirmDeleteDialog.vue?vue&type=template&id=66ad5b7d&scoped=true&"
import script from "./ConfirmDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmDeleteDialog.vue?vue&type=style&index=0&id=66ad5b7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad5b7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
